"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as m } from "react";
import o from "../components/Icon/SvgIcon.js";
const h = (c) => /* @__PURE__ */ a(
  o,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.721 19.375c0 .758-.617 1.375-1.375 1.375H8.625a1.377 1.377 0 0 1-1.375-1.375V8.531c0-.758.617-1.375 1.375-1.375h6.721c.758 0 1.375.617 1.375 1.375zm-9.471-16a.13.13 0 0 1 .125-.125h9.221a.13.13 0 0 1 .125.125v2.406a.13.13 0 0 1-.125.125H7.375a.13.13 0 0 1-.125-.125zm10.721 2.406V3.375c0-.758-.617-1.375-1.375-1.375H7.375C6.617 2 6 2.617 6 3.375v2.406c0 .463.232.871.583 1.12A2.6 2.6 0 0 0 6 8.531v10.844A2.63 2.63 0 0 0 8.625 22h6.721a2.63 2.63 0 0 0 2.625-2.625V8.531c0-.618-.224-1.18-.583-1.63a1.37 1.37 0 0 0 .583-1.12m-6.492 6.057a.3.3 0 0 1-.148.102c-.04.012-.193.042-.76.042h-.464v-.652h.5c.493 0 .61.009.638.013a.37.37 0 0 1 .22.1q.067.07.066.202a.33.33 0 0 1-.052.193m3.829 5.643-1.475-2.063 1.52-2.205-.04-.074c-.038-.074-.09-.095-.383-.095h-.755c-.2 0-.433.126-.544.293l-.581.885-.216-.322q-.367-.556-.595-.788a3 3 0 0 0-.158-.142q.368-.132.605-.375.385-.402.387-1.012-.001-.477-.253-.851a1.34 1.34 0 0 0-.683-.527c-.262-.092-.663-.137-1.223-.137H9.009a.415.415 0 0 0-.414.415v4.52c0 .228.187.413.415.413h.6a.414.414 0 0 0 .414-.413V13.2c.247 0 .367.023.425.042a.6.6 0 0 1 .217.142c.058.058.192.218.502.654l.748 1.043.216.305-1.668 2.367.038.075c.04.079.105.095.384.095h.795a.72.72 0 0 0 .546-.286l.754-1.09.898 1.303c.04.055.069.073.399.073h.803c.126 0 .224-.051.27-.141.045-.09.03-.2-.043-.301M8.887 5.099a.625.625 0 0 0 1.25 0V4.058a.625.625 0 0 0-1.25 0zm3.099.625a.625.625 0 0 1-.625-.625V4.058a.625.625 0 0 1 1.25 0v1.04c0 .346-.28.626-.625.626m1.848-.625a.625.625 0 0 0 1.25 0V4.058a.625.625 0 0 0-1.25 0z",
        clipRule: "evenodd"
      }
    )
  }
), t = m(h);
export {
  t as Pharmacy,
  t as default
};
